import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const MobileMenu = ({ isOpen, onClose, links }) => {
  const menuVariants = {
    closed: {
      opacity: 0,
      y: "-100%",
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1], // Custom ease for smooth "heavy" feel
        staggerChildren: 0.05,
        staggerDirection: -1
      }
    },
    open: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.22, 1, 0.36, 1],
        staggerChildren: 0.07,
        delayChildren: 0.2
      }
    }
  };

  const linkVariants = {
    closed: {
      y: 30,
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: "easeIn"
      }
    },
    open: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: "easeOut"
      }
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial="closed"
          animate="open"
          exit="closed"
          variants={menuVariants}
          className="fixed inset-0 z-[60] bg-[#0F0F23]/98 backdrop-blur-xl flex flex-col justify-center items-center"
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-6 right-6 text-white/50 hover:text-white transition-colors p-2"
            aria-label="Close menu"
          >
            <i className="fas fa-times text-5xl"></i>
          </button>

          {/* Menu Links */}
          <nav className="flex flex-col items-center space-y-8">
            {links.map((link) => (
              <motion.div
                key={link.path || link.href}
                variants={linkVariants}
              >
                <Link
                  to={link.path || link.href}
                  onClick={onClose}
                  className="text-4xl sm:text-5xl font-bold text-white tracking-widest hover:text-[#06B6D4] transition-colors relative group block"
                >
                    {link.label}
                    <span className="absolute -bottom-2 left-0 w-0 h-1 bg-[#7C3AED] transition-all duration-300 group-hover:w-full"></span>
                </Link>
              </motion.div>
            ))}
          </nav>

          {/* Footer / Socials (Optional decoration) */}
          <motion.div 
            variants={linkVariants}
            className="absolute bottom-10 flex space-x-6"
          >
            <div className="w-12 h-1 bg-[#7C3AED]/20 rounded-full"></div>
            <div className="w-12 h-1 bg-[#06B6D4]/20 rounded-full"></div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileMenu;
